<template>
  <div>
    <div class="container-login">
      <div class="wrap-all-login">
        <div class="left-tips-box left">
          <div class="logo"><img :src="urlImg + logo" /></div>
          <div class="text">
            <p>科汇云，让技术转移与成果转化变得简单起来。</p>
          </div>
        </div>
        <!-- 登录/注册 -->
        <div class="fh_register right" v-show="pass">
          <el-tabs v-model="activeName">
            <el-tab-pane label="登录" name="first">
              <div class="fh_register_b">
                <div class="fh_label_f">
                  <input
                    type="text"
                    placeholder="请输入手机号"
                    v-model="phone"
                    maxlength="11"
                  />
                </div>
                <div class="fh_label_f" v-show="show">
                  <input
                    type="text"
                    placeholder="输入验证码"
                    class="fh_code"
                    v-model="inputCode"
                  />
                  <span class="fh_get" v-show="btnBool" @click="getCode"
                    >获取验证码</span
                  >
                  <span v-show="!btnBool" class="fh_get">{{ count }} 秒</span>
                </div>
                <div class="fh_label_f" v-show="!show">
                  <input
                    type="password"
                    placeholder="请输入密码"
                    v-model="password"
                  />
                </div>

                <p class="fh_read">
                  登录即表示您同意
                  <span>
                    <router-link
                      target="_blank"
                      class="blue"
                      :to="{ path: 'member-service' }"
                    >
                      《科汇云会员服务协议》
                    </router-link>
                    <router-link
                      target="_blank"
                      class="blue"
                      :to="{ path: 'trading-service' }"
                    >
                      《科汇云交易服务协议》
                    </router-link>
                    <router-link
                      target="_blank"
                      class="blue"
                      :to="{ path: 'privacy-protection' }"
                    >
                      《隐私保护声明》
                    </router-link>
                  </span>
                </p>
                <el-button
                  type="primary"
                  class="fh_logining"
                  @click="Dlogin"
                  v-show="show"
                  >立即登录</el-button
                >
                <el-button
                  type="primary"
                  class="fh_logining"
                  @click="login"
                  v-show="!show"
                  >立即登录</el-button
                >
                <div class="fh_type">
                  <span class="left" @click="zmLogin" v-show="show"
                    >账号密码登录</span
                  >
                  <span class="left" @click="dmLogin" v-show="!show"
                    >动态密码登录</span
                  >
                  <span class="right" @click="wjmm">忘记密码?</span>
                </div>
                <div class="wx-bottom-entry" @click="goWxLogin" title="微信扫码登录">
                  <svg viewBox="0 0 1024 1024" width="28" height="28">
                    <path d="M690.1 377.4c5.9 0 11.8 0.2 17.6 0.5-24.4-128.7-158.3-227.1-313.4-227.1C209 150.8 56.7 281.9 56.7 444.6c0 93.3 50.8 168.3 135.2 227.2l-33.8 101.8 118.4-59.1c42.5 8.4 76.6 16.8 118.4 16.8 5.6 0 11.2-0.2 16.8-0.6-3.5-17.6-5.5-35.6-5.5-54.2 0-160.5 135.1-299.1 283.9-299.1zM498 319.6c25.2 0 42 16.8 42 42.1 0 25.2-16.8 42.1-42 42.1s-50.4-16.8-50.4-42.1c0-25.3 25.2-42.1 50.4-42.1zM279.4 403.7c-25.2 0-50.4-16.8-50.4-42.1 0-25.2 25.2-42.1 50.4-42.1s42 16.8 42 42.1c0 25.3-16.8 42.1-42 42.1zM943.3 675.7c0-134.7-134.7-244.3-286.4-244.3-159.3 0-286.5 109.6-286.5 244.3s127.2 244.3 286.5 244.3c33.6 0 67.2-8.4 100.8-16.8l92.5 50.4-25.2-84.2c67.2-50.4 118.3-117.7 118.3-193.7zM598.6 642.1c-16.8 0-33.6-16.8-33.6-33.7 0-16.8 16.8-33.6 33.6-33.6s33.6 16.8 33.6 33.6c0 16.9-16.8 33.7-33.6 33.7zM707.9 642.1c-16.8 0-33.6-16.8-33.6-33.7 0-16.8 16.8-33.6 33.6-33.6s33.6 16.8 33.6 33.6c0 16.9-16.8 33.7-33.6 33.7z" fill="#07C160"/>
                  </svg>
                  <span>微信扫码登录</span>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="注册" name="second">
              <Register @onChild="onChild"></Register>
            </el-tab-pane>
          </el-tabs>
        </div>
        <!-- 忘记密码 -->
        <div class="fh_register right" v-show="!pass">
          <Forget @Pass="Pass"></Forget>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Register from "./register";
import Forget from "./forget";
import { Send_Sms, Login, DLogin, Logo } from "@/common/js/api";
import { urlImg } from "@/common/js/url";
export default {
  name: "LoginNei",
  components: {
    Register,
    Forget,
  },
  data() {
    return {
      activeName: "first",
      inputCode: "",
      phone: "",
      password: "",
      btnBool: true,
      count: "",
      show: true,
      pass: true,
      step: true,
      timer: null,
      checked: false,
      logo: "",
      urlImg: "",
    };
  },
  created() {
    this.getLogo();
    this.urlImg = urlImg();
  },
  methods: {
    getLogo() {
      Logo({})
        .then((res) => {
          this.logo = res.data.logo;
        })
        .catch(() => {});
    },
    onChild(val) {
      this.activeName = val;
    },
    Pass(val) {
      this.pass = val;
    },
    goWxLogin() {
      const redirect = this.$route.query.redirect;
      this.$router.push({
        path: '/login/wx',
        query: redirect ? { redirect } : {},
      });
    },
    getCode() {
      if (
        this.phone != null &&
        this.phone != "" &&
        /^((1[3,5,8,7,9][0-9])|(14[5,7])|(17[0,6,7,8])|(19[1,7]))\d{8}$/.test(
          this.phone
        )
      ) {
        this.getyzm();
        Send_Sms({
          phone: this.phone,
        })
          .then((res) => {
            if (res.code == 200) {
              this.$message.success("验证码发送成功，请注意查收短信");
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch(() => {});
      } else {
        this.$message.error("请输入正确的11位手机号");
      }
    },
    getyzm() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.btnBool = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.btnBool = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    afterLoginSuccess(res) {
      localStorage.setItem("user", JSON.stringify(res.data.user));
      window.localStorage.setItem("token", res.data.access_token);
      const redirect = this.$route.query.redirect;
      if (redirect && typeof redirect === "string") {
        this.$router.push(redirect);
      } else {
        this.$router.push({ path: "/home" });
      }
    },
    login() {
      Login({
        phone: this.phone,
        password: this.password,
      })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.afterLoginSuccess(res);
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(() => {});
    },
    Dlogin() {
      DLogin({
        phone: this.phone,
        code: this.inputCode,
      })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.afterLoginSuccess(res);
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(() => {});
    },
    zmLogin() {
      this.show = false;
    },
    dmLogin() {
      this.show = true;
    },
    wjmm() {
      this.pass = false;
    },
  },
};
</script>
 <style scoped src="./login.css"></style>
<style scoped lang="less">
#app .nav-bar .nav-top,
.el-container {
  display: none !important;
}
.container-login::before {
  content: "";
  background-color: #000;
  opacity: 0.6;
  z-index: -1;
  background-size: 500px 300px;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  border-radius: 40px;
}
.container-login {
  min-height: 100vh;
  display: flex;
  align-items: center;
  background: #f8f9fa;
  background: url(../../../assets/img/home/bg.jpg) 0 0 no-repeat;
  background-size: cover;
  position: relative;
  z-index: 99;
  .wrap-all-login {
    width: 734px;
    height: 520px;
    margin: auto;
    background: #fff;
    overflow: hidden;
    .left-tips-box {
      width: 315px;
      height: 100%;
      background: #4470f3;
      padding: 97px 58px 0;
      color: #fff;
      font-size: 12px;
      overflow: hidden;
      line-height: 1.5;
      .logo {
        margin-bottom: 30px;
        width: 169px;
        height: 54px;
      }
    }
    .fh_register {
      width: 404px;
      height: 100%;
      padding: 56px 36px 16px 48px;
      box-sizing: border-box;
      overflow-y: auto;
    }
  }
}
/deep/.el-tabs__nav-scroll {
  padding-left: 80px;
}
/deep/.el-button + .el-button {
  margin-left: 0;
}
</style>
